import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { indexOf, isEmpty, includes, filter, get } from 'lodash';
import { resolveNotesPlayer, resolveNotesSurvey } from 'selectors';
import QuestionNotesContainer from './QuestionNotesContainer';
import NotesHeader from 'components/notes/NotesHeader';


const SurveyNotesContainer = ({ params, player, notesSurvey, survey, notes }) => {
  if (!notesSurvey || !survey || !player) return null;
  const questionSections =
    survey.entities.questionnaires[notesSurvey.questionnaire].sections.map(s => {
      const section = survey.entities.sections[s];
      const questions = filter(section.questions, q => includes(notes.result, q));
      if (isEmpty(questions)) return null;
      const questionNotes = questions.map( q => {
        const qNumber = indexOf(section.questions, q) + 1;
        const questionParams = {...params, ...{ asqQuestionId: q }};
        return <QuestionNotesContainer key={`q-${q}`} asqQuestionId={q} qNumber={qNumber} params={questionParams} survey={survey} />
      });
      return (
        <section key={`s-${s}`} className='o-webnote-section o-modal__content-wrap'>
          <div className='column'>
            <hr className='u-hr--answer'/>
            <h2 className='u-txt--base'><b>{section.name}</b></h2>
          </div>
          {questionNotes}
        </section>
      );
    });
  return (
    <div className='column'>
      <NotesHeader player={player} questionnaire={notesSurvey} />
      <div className='o-modal__content row'>
        {questionSections}
      </div>
    </div>
  );
}

SurveyNotesContainer.propTypes = {
  notes: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  player: PropTypes.object,
  survey: PropTypes.object,
  notesSurvey: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => {
  const survey = resolveNotesSurvey(state, ownProps);
  return {
    params: ownProps.params,
    notes: state.modal.meta,
    player: resolveNotesPlayer(state, ownProps),
    notesSurvey: get(survey, `entities.surveys[${get(survey, 'result.questionnaires.parent')}]`, null),
    survey,
  }
}

export default connect(mapStateToProps, null)(SurveyNotesContainer);
